import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bce69a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { class: "search-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref, computed, watchEffect, onMounted } from "vue";
import { useStore } from "vuex";



import AGDataGrid from "./AGDataGrid.vue";
import EmailCard from "./EmailCard.vue";
import SelectBoxWithIconVue from "../UserSelectable/SelectBoxWithIcon.vue";
import EmailTagger from "./EmailTagger.vue";
import { doingTasks } from "./data.js";
// import { myHub } from '../../../../core/signalr/clients/EmailDataHub'

import DxTextBox from "devextreme-vue/text-box";

import { EmailData } from "../../types/EmailTypes";


export default /*#__PURE__*/_defineComponent({
  props: {
  Emails: Array
},
  setup(__props) {

const props = __props


const store = useStore();
// store.commit("extractTagsFromEmails", store.state.Emails.emails);
// store.commit('extractAttachmentDescriptions', store.state.Emails.emails)

const emails = computed(() => props.Emails || store.state.Emails.emails);
let setFilter = null;

// onMounted(() => {
  setTimeout(() => {

    setFilter = computed(() => store.getters.tagsFilter);
  },500)
// })

let searchTerm = ref("");
function removeText() {
  searchTerm.value = "";
}
let textEntered = computed(() => searchTerm.value.length > 0);

function addFilter(filter) {
  console.log("🚀 ~ addFilter ~ filter:", filter)
  store.commit("tagsFilter", filter);
}

let columnDefs = ref([
  { headerName: "From", field: "from" },
  { headerName: "Subject", field: "subject" },
   { headerName: "Body", field: "body", cellStyle: { "white-space": "normal" } },
  { headerName: "Files", field: "attachments.length", width: 70 },
  { headerName: "Tags", field: "totalTags", width: 70},
  {
    headerName: "Tags",
    field: "ModelsTags",
    cellRenderer: "ModelTagsCellRenderer",
    autoHeight: true,
    // flex: 1 
  },
  { headerName: "Time", field: "sentTime", cellRenderer: "TimeDisplay", width: 70 },
]);

// myHub.on('update', (p: any, v: any) => {
//   store.dispatch('addEmail', p)
// })

// interface EmailData {
//   timeReceived: String
//   Subject: String
//   sourceAddress: String
//   attachments: String
//   bodySize: Number
// }

let showCard = ref(false);
let emailCardData = ref({});

const displayCard = (emailData: EmailData) => {
  console.log(emailData);
  emailCardData.value = emailData;
  showCard.value = true;
};

function closeCard() {
  showCard.value = false;
}

async function loadEmails() {
  let apiURL = "ventureAPI";
  const res = await fetch(`${apiURL}/getEmails`);
}

///   USED FOR TESTING WHEN NO SIGNAL R

// function addEmails

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SelectBoxWithIconVue, {
        selectedValue: _unref(store).state.Emails.tagsFilter,
        dataSource: _unref(store).state.Emails.extractedTags,
        onSelectedItem: addFilter
      }, null, 8, ["selectedValue", "dataSource"]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(DxTextBox), {
            height: "44",
            width: "300",
            placeholder: "Search ...",
            onEnterKey: _ctx.parseArrOfStr,
            modelValue: _unref(searchTerm),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTerm) ? searchTerm.value = $event : searchTerm = $event))
          }, null, 8, ["onEnterKey", "modelValue"]),
          (_unref(textEntered))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "deselect-tags",
                onClick: removeText
              }, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "search-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.parseArrOfStr && _ctx.parseArrOfStr(...args)))
          }, "Search")
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(AGDataGrid, {
        onClickedRow: displayCard,
        columnDefs: _unref(columnDefs),
        dataSource: _unref(emails),
        filter: _unref(store).getters.tagsFilter,
        textFilter: _unref(searchTerm)
      }, null, 8, ["columnDefs", "dataSource", "filter", "textFilter"])
    ])
  ]))
}
}

})